export enum ConnectedAccountKybStatus {
    Pending = 'pending',
    Submitted = 'submitted',
    Active = 'active',
    Suspended = 'suspended',
    ActionRequired = 'action-required',
    Disabled = 'disabled',
}
